// Variáveis {{x}} de e-mail (actions de e-mail da automação) — espelha a validação do backend
// (AutomationController.ValidateEmailActionPlaceholdersAsync): toda variável do assunto/corpo precisa
// estar no conjunto permitido do target; em chamado, {{ticket.<campo>.previous|current}} também vale
// (campos alterados, resolvidos pelo PlaceholderParser sem tb_place_holder).

const PLACEHOLDER_REGEX = /\{\{([^}]+)\}\}/g;
const CHANGED_FIELD_REGEX = /^\{\{\s*ticket\.[a-z_]+\.(previous|current)\s*\}\}$/i;

export const extractPlaceholders = (text) => {
  const found = [];
  const source = text || '';
  let match;
  PLACEHOLDER_REGEX.lastIndex = 0;
  while ((match = PLACEHOLDER_REGEX.exec(source)) !== null) {
    const normalized = `{{${match[1].trim()}}}`;
    if (!found.some((item) => item.toLowerCase() === normalized.toLowerCase())) found.push(normalized);
  }
  return found;
};

// allowedNames: lista de nomes no formato "{{ticket.id}}" (campo name do endpoint).
export const findUnknownPlaceholders = (texts, allowedNames, targetEntity) => {
  const allowed = new Set((allowedNames || []).map((name) => (name || '').toLowerCase()));
  const isChat = (targetEntity || '').toLowerCase() === 'chat';
  return extractPlaceholders((texts || []).join(' ')).filter(
    (item) => !allowed.has(item.toLowerCase()) && (isChat || !CHANGED_FIELD_REGEX.test(item))
  );
};
